<template>
  <CollaboratorFormModal
    ref="formModal"
    :scope="scope"
    :available-roles="availableRoles"
    :limits-usage="limitsUsage"
    :can-bypass-limits="canBypassLimits"
    entry-type="username"
    header-icon="cipRobot"
    :show-personal-message="false"
    modal-class="modal-v-user"
    :entry-placeholder="$pgettext('collaborators.virtualusers', 'e.g., photographer (press Enter to add)')"
    @submit="handleSubmit"
  >
    <template #title>
      <translate translate-context="collaborators.virtualusers">Create virtual users</translate>
    </template>

    <template #description>
      <p>
        <translate translate-context="collaborators.virtualusers">Virtual users are accounts without a real email
          address. Credentials will be automatically generated and displayed after creation.
        </translate>
      </p>
    </template>

    <template #entry-label>
      <translate translate-context="collaborators.virtualusers">Usernames</translate>
    </template>

    <template #entry-count-label>
      <translate translate-context="collaborators.virtualusers">user(s)</translate>
    </template>

    <template #submit-text>
      <translate translate-context="collaborators.virtualusers">Create Virtual Users</translate>
    </template>

    <template #no-roles-text>
      <translate translate-context="collaborators.virtualusers">
        No roles available for virtual users in this event.
      </translate>
    </template>
  </CollaboratorFormModal>
</template>

<script>
import {mapActions} from 'vuex'
import CollaboratorFormModal from './CollaboratorFormModal.vue'

export default {
  name: 'VirtualUserModal',

  components: {
    CollaboratorFormModal
  },

  props: {
    scope: {
      type: Object,
      required: true
    },
    availableRoles: {
      type: Array,
      default: () => []
    },
    limitsUsage: {
      type: Object,
      default: null
    },
    canBypassLimits: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions('collaborators', [
      'createVirtualUsers',
      'fetchCollaborators'
    ]),

    open() {
      this.$refs.formModal.open()
    },

    close() {
      this.$refs.formModal.close()
    },

    async handleSubmit({entries, roleIds}) {
      try {
        const result = await this.createVirtualUsers({
          users: entries,
          roles: roleIds
        })

        if (result.success_count > 0) {
          const successMsg = this.$pgettext('collaborators.virtualusers', '{count} virtual user(s) created successfully.')
            .replace('{count}', result.success_count)
          await this.notifySuccess(successMsg)

          this.$emit('virtual-users-created', result.credentials)
        }

        if (result.error_count > 0 && result.errors && Object.keys(result.errors).length > 0) {
          const errorMessages = Object.entries(result.errors)
            .map(([username, error]) => {
              if (typeof error === 'object' && error.code) {
                return `${username}: ${this.$refs.formModal.translateLimitError(error.code, error.detail)}`
              }
              return `${username}: ${this.$refs.formModal.translateLimitError(error)}`
            })
            .join('\n')
          await this.notifyError(
            this.$pgettext('collaborators.notification', 'Some operations failed:\n') + errorMessages
          )
        }

        this.close()
        await this.fetchCollaborators()
      } catch (error) {
        const errorCode = error.data?.code
        const errorMessage = this.$refs.formModal.translateLimitError(errorCode, error.data?.detail)
        await this.notifyError(errorMessage)
      }
    }
  }
}
</script>
